/* swt-product-grid-facets.js
   Behavioural fixes for the SWT product grid facets.
   NOTE: the responsive CSS layer that used to be injected from here now
   lives in assets/swt-collection.css (section "v5"). Keep styles there —
   injecting CSS after DOMContentLoaded caused a visible layout jump on
   every collection page load. */
(function () {
  var run = function () {
    var FacetForm = customElements.get('facet-filters-form');
    if (!FacetForm) return;

    var parseHtml = function (html) {
      return new DOMParser().parseFromString(html, 'text/html');
    };

    var normalizeMobileSortForms = function () {
      var forms = Array.prototype.slice.call(document.querySelectorAll('#ProductGridContainer form#FacetFiltersFormMobile'));
      forms.forEach(function (form) {
        if (form.querySelector('[name="sort_by"]')) {
          form.id = 'FacetSortDrawerForm';
          var select = form.querySelector('#SortBy');
          var label = form.querySelector('label[for="SortBy"]');
          if (select) select.id = 'SortByMobile';
          if (label) label.setAttribute('for', 'SortByMobile');
        }
      });
    };

    normalizeMobileSortForms();

    if (window.SWTProductGridFacetFixesApplied) return;
    window.SWTProductGridFacetFixesApplied = true;

    var facetKey = function (details) {
      return details.id || details.dataset.index || (details.querySelector('summary') && details.querySelector('summary').textContent.trim());
    };

    var getOpenFacetKeys = function () {
      return Array.prototype.slice.call(document.querySelectorAll('#main-collection-filters details[open]'))
        .map(facetKey)
        .filter(Boolean);
    };

    var restoreOpenFacetKeys = function (keys) {
      if (!keys || !keys.length) return;
      Array.prototype.slice.call(document.querySelectorAll('#main-collection-filters details')).forEach(function (details) {
        var key = facetKey(details);
        if (key && keys.indexOf(key) !== -1) details.setAttribute('open', '');
      });
    };

    /* A11y: innerHTML replacement destroys the element that held keyboard
       focus (usually the checkbox just toggled), dropping focus to <body>.
       Capture a fingerprint of the focused control before the swap and
       re-focus its equivalent in the new DOM afterwards. */
    var captureFocus = function (container) {
      var active = document.activeElement;
      if (!active || active === document.body || !container.contains(active)) return null;
      return {
        id: active.id || '',
        name: active.getAttribute ? (active.getAttribute('name') || '') : '',
        value: typeof active.value === 'string' ? active.value : ''
      };
    };

    var restoreFocus = function (container, fingerprint) {
      if (!fingerprint) return;
      var el = null;
      try {
        if (fingerprint.id) el = document.getElementById(fingerprint.id);
        if (!el && fingerprint.name && window.CSS && CSS.escape) {
          var selector = '[name="' + CSS.escape(fingerprint.name) + '"]';
          if (fingerprint.value) selector += '[value="' + CSS.escape(fingerprint.value) + '"]';
          el = container.querySelector(selector);
        }
      } catch (e) { el = null; }
      if (el && typeof el.focus === 'function') el.focus();
    };

    var clearLoadingState = function () {
      Array.prototype.slice.call(document.querySelectorAll('.facets-container facet-remove, .facets__form .loading__spinner')).forEach(function (element) {
        element.classList.add('hidden');
      });
      var productGridContainer = document.getElementById('ProductGridContainer');
      if (productGridContainer) {
        var collection = productGridContainer.querySelector('.collection');
        if (collection) collection.classList.remove('loading');
      }
    };

    var updateProductCounts = function (doc) {
      var source = doc.getElementById('ProductCountDesktop') || doc.getElementById('ProductCount') || doc.querySelector('[data-product-count]');
      if (!source) {
        clearLoadingState();
        return;
      }

      Array.prototype.slice.call(document.querySelectorAll('#ProductCount, #ProductCountDesktop, [data-product-count]')).forEach(function (target) {
        target.innerHTML = source.innerHTML;
      });

      clearLoadingState();
    };

    var normalizeSearchParams = function (searchParams) {
      if (typeof searchParams !== 'string') return searchParams;
      var params = new URLSearchParams(searchParams);
      var sortValues = params.getAll('sort_by');
      if (sortValues.length > 1) {
        params.delete('sort_by');
        params.set('sort_by', sortValues[sortValues.length - 1]);
      }
      return params.toString();
    };

    FacetForm.renderProductGridContainer = function (html) {
      var doc = parseHtml(html);
      var current = document.getElementById('ProductGridContainer');
      var next = doc.getElementById('ProductGridContainer');
      if (!current || !next) return;

      var openFacetKeys = getOpenFacetKeys();
      var focusFingerprint = captureFocus(current);
      current.innerHTML = next.innerHTML;
      restoreOpenFacetKeys(openFacetKeys);
      normalizeMobileSortForms();
      restoreFocus(current, focusFingerprint);

      if (typeof initializeScrollAnimationTrigger === 'function') {
        initializeScrollAnimationTrigger(current);
      }
    };

    FacetForm.renderProductCount = function (html) {
      updateProductCounts(parseHtml(html));
    };

    FacetForm.renderSectionFromFetch = function (url) {
      if (FacetForm.swtAbortController) FacetForm.swtAbortController.abort();
      FacetForm.swtAbortController = new AbortController();

      fetch(url, { signal: FacetForm.swtAbortController.signal })
        .then(function (response) { return response.text(); })
        .then(function (responseText) {
          FacetForm.filterData = [].concat(FacetForm.filterData, [{ html: responseText, url: url }]);
          FacetForm.renderProductGridContainer(responseText);
          FacetForm.renderProductCount(responseText);
        })
        .catch(function (error) {
          if (error.name !== 'AbortError') {
            console.error('SWT product grid filter update failed:', error);
            clearLoadingState();
          }
        });
    };

    FacetForm.renderSectionFromCache = function (filterDataUrl) {
      var matcher = typeof filterDataUrl === 'function'
        ? filterDataUrl
        : function (item) { return item.url === filterDataUrl; };
      var cached = FacetForm.filterData.find(matcher);
      if (!cached) {
        clearLoadingState();
        return;
      }
      FacetForm.renderProductGridContainer(cached.html);
      FacetForm.renderProductCount(cached.html);
    };

    var originalOnSubmitForm = FacetForm.prototype.onSubmitForm;
    FacetForm.prototype.onSubmitForm = function (searchParams, event) {
      var normalized = normalizeSearchParams(searchParams);
      var now = Date.now();
      if (FacetForm.searchParamsPrev === normalized && FacetForm.swtLastSubmitAt && now - FacetForm.swtLastSubmitAt < 900) return;
      FacetForm.swtLastSubmitAt = now;
      originalOnSubmitForm.call(this, normalized, event);
    };

    var originalOnSubmitHandler = FacetForm.prototype.onSubmitHandler;
    FacetForm.prototype.onSubmitHandler = function (event) {
      normalizeMobileSortForms();

      if (!event || !event.target || !event.target.closest) return originalOnSubmitHandler.call(this, event);

      var form = event.target.closest('form');
      if (!form) return originalOnSubmitHandler.call(this, event);

      if (form.id !== 'FacetFiltersFormMobile' && form.id !== 'FacetSortDrawerForm') {
        return originalOnSubmitHandler.call(this, event);
      }

      var formData = new FormData(form);
      if (form.id === 'FacetSortDrawerForm') {
        var mobileFilterForm = document.querySelector('#ProductGridContainer form#FacetFiltersFormMobile');
        if (mobileFilterForm && mobileFilterForm !== form) {
          new FormData(mobileFilterForm).forEach(function (value, key) {
            if (key.indexOf('filter.') === 0 && value !== '') formData.append(key, value);
          });
        }
      }

      this.onSubmitForm(new URLSearchParams(formData).toString(), event);
    };

    document.addEventListener('change', function (event) {
      var target = event.target;
      if (!target || !target.closest || !target.matches) return;
      if (!target.closest('#ProductGridContainer facet-filters-form')) return;
      if (!target.matches('select, input[type="checkbox"], input[type="radio"], input[type="range"]')) return;

      var host = target.closest('facet-filters-form');
      if (host && typeof host.onSubmitHandler === 'function') host.onSubmitHandler(event);
    }, true);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  document.addEventListener('shopify:section:load', run);
})();
